import { GlobalStyles, ThemeProvider } from "@mui/material";
import { RouterProvider } from "react-router-dom";

import palette from "assets/palette";
import theme from "assets/theme";
import router from "routes";
import { store } from "store";
import { Provider } from "react-redux";
import Toast from "components/Toast";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

// Create a client
const queryClient = new QueryClient();
function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <Provider store={store}>
          <GlobalStyles
            styles={{
              body: { backgroundColor: palette.primary.main },
            }}
          />
          <RouterProvider router={router} />
          <Toast />
        </Provider>

      </ThemeProvider>
    </QueryClientProvider>
  );
}

export default App;
